import { dbInstallTfFactory } from "@p0security/integrations-db";

export const installTf = dbInstallTfFactory("pg", {
  version: "0.3.0",
  arguments: ({ type, rdsArnRef }) =>
    `${type === "cluster" ? "rds_cluster_arn" : "rds_instance_arn"} = ${rdsArnRef}`,
});
